import type {AlertProps} from 'src/design/atoms/Alert';
import {Anchor} from 'src/design/atoms/Anchor';
import {Link} from 'react-router-dom';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {ErrorAlert} from 'src/design/molecules/ErrorAlert';

export interface ServerErrorAlertProps extends AlertProps {
  message?: string;
  error?: any;
}
export const ServerErrorAlert: React.FC<ServerErrorAlertProps> = ({
  message,
  error,
  ...other
}) => {
  return (
    <ErrorAlert
      message={message}
      error={error}
      contactLink={
        <Anchor
          c="black"
          td="underline"
          size="sm"
          component={Link}
          to={PathUtility.Contact()}>
          Contact us
        </Anchor>
      }
      {...other}
    />
  );
};
